import { Empty, Spin } from 'antd'
import Pagination from 'components/Pagination'
import {
  FlexWrap,
  RowNumberData, RowNumberDriveAlignCenter,
  Wrapper
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStyles'
import DriveActonInfo from 'modules/Exp-Candidates/Components/DriveTable/Actions/index'
import Drivefilter from 'modules/Exp-Candidates/Components/DriveTable/Drivefilter/index'
import {
  EmptyWrapper
} from 'modules/Exp-Candidates/Components/Styles/style'
import React from 'react'

const UpcomingTable = ({
  listOfDrivesDetails,
  onPageChange,
  currentPage,
  searchValue,
  setSearchValue,
  driveRoles,
  setDriveRoles,
  driveMode,
  setDriveMode,
  driveStatus,
  setDrivestatus,
  filteApplied,
  isLoading,
  corporateStatus,
  onChangeSort,
  occurrence,
}) => {
 

  const getNoData = () => {
    if (occurrence === 'UPCOMING') {
      return 'No upcoming drives found!'
    } else if (occurrence === 'PAST') {
      return 'No past drives found!'
    } else {
      return 'No ongoing drives found!'
    }
  }

  const columns = [
    {
      title: 'Roles',
      dataIndex: 'tittle',
      key: 'tittle',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: driveRoleMap => {
        return (
          <FlexWrap alignCenter gap="8px">
            <RowNumberData>{driveRoleMap}</RowNumberData>
          </FlexWrap>
        )
      },
    },
    {
      title: 'Total Cand.',
      dataIndex: 'totalCandidate',
      sorter: false,
      key: 'totalCandidate',
      align: 'center',
      sortDirections: ['ascend', 'descend'],
      render: driveId => <RowNumberDriveAlignCenter>{driveId}</RowNumberDriveAlignCenter>,
    },

    {
      title: 'Active Cand.',
      dataIndex: 'shortListedCandidate',
      sorter: false,
      key: 'shortListedCandidate',
      align: 'center',
      sortDirections: ['ascend', 'descend'],
      render: driveMode => <RowNumberDriveAlignCenter>{driveMode}</RowNumberDriveAlignCenter>,
    },
    {
      title: 'Hired Cand.',
      dataIndex: 'activeCandidate',
      sorter: false,
      key: 'activeCandidate',
      align: 'center',
      sortDirections: ['ascend', 'descend'],
      render: (_,data) => <RowNumberDriveAlignCenter>{data?.selectedCandidate}</RowNumberDriveAlignCenter>,
    },
    {
      title: ' Rejected Cand.',
      dataIndex: 'rejectedCandidate',
      sorter: false,
      key: 'rejectedCandidate',
      align: 'center',
      sortDirections: ['ascend', 'descend'],
      render: data => <RowNumberDriveAlignCenter>{data}</RowNumberDriveAlignCenter>,
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      sortDirections: ['ascend', 'descend'],
      render: (_, drive) => <DriveActonInfo disabled={drive?.totalCandidate === 0} drive={drive} />,
    },
  ]

  return (
    <Wrapper>
      <Drivefilter
        driveRoles={driveRoles}
        setDriveRoles={setDriveRoles}
        driveMode={driveMode}
        setDriveMode={setDriveMode}
        driveStatus={driveStatus}
        setDrivestatus={setDrivestatus}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        filteApplied={filteApplied}
        corporateStatus={corporateStatus}
        currentCount={
          listOfDrivesDetails?.count < 10
            ? listOfDrivesDetails?.count
            : (listOfDrivesDetails?.page + 1) * 10 -
              10 +
              listOfDrivesDetails?.result?.length
        }
        totalCount={listOfDrivesDetails?.count}
      />
      <StyledTable
        pagination={false}
        rowKey="id"
        columns={columns}
        dataSource={listOfDrivesDetails?.result || []}
        onChange={onChangeSort}
        locale={{
          emptyText: (
            <EmptyWrapper center isSpin={!isLoading}>
              {isLoading ? <Empty description={getNoData()} /> : <Spin />}
            </EmptyWrapper>
          ),
        }}
      />
      <Pagination
        onChange={onPageChange}
        totalPages={listOfDrivesDetails?.count}
        pageSize={10}
        current={currentPage + 1}
      />
    </Wrapper>
  )
}

export default UpcomingTable
